// extracted by mini-css-extract-plugin
export default {"nailSoftColumn":"tableColumns_nailSoftColumn__TcCUR","nailSoftContainer":"tableColumns_nailSoftContainer__SLkA5"};